module.exports = __webpack_public_path__ + "static/vision-6329e6fe7c9b501b89effec2e4e2607f.png";